import * as yup from 'yup';
import IBAN from 'iban';


export const schemaPayment = yup.object()
    .shape({
        next_IBAN: yup.string()
            .required('Bitte geben Sie Ihre IBAN an.')
            .test('isValidIban', 'Bitte geben Sie ein korrektes IBAN Format ein.', IBAN.isValid)
            .max(34, 'Eine IBAN besteht aus maximal 34 Zeichen.')
            .matches(/^(AD|AT|AX|BE|CY|DE|EE|ES|FI|FR|GR|IE|IT|LV|LT|LU|MT|MC|NL|PT|SM|SK|SI)/,
                'Leider akzeptieren wir nur IBANs von Andorra, Österreich, Belgien, Zypern, Estland, Finnland, ' +
                'Åland-Inseln, Frankreich, Deutschland, Griechenland, Irland, Italien, Lettland, Litauen, Luxemburg, ' +
                'Malta, Monaco, Niederlande, Portugal, Azoren, Madeira, San Marino, Slowakei, Slowenien, Spanien und ' +
                'die Kanarischen Inseln.'),
        next_sepaTerms: yup.boolean()
            .oneOf([true], 'Bitte akzeptieren Sie das SEPA-Mandat.')
            .typeError('Bitte akzeptieren Sie das SEPA-Mandat.'),
    });
